import type { VueConstructor } from 'vue';

import CodementumUrlStoreFacade from './store/url.js';

interface PluginOptions {
  store: {
    registerModule: (name: string, module: unknown) => void;
    [key: string]: unknown;
  };
}

const CodementumUrlPlugin = {
  install(Vue: VueConstructor, options: PluginOptions) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with Vuex store');
    }

    options.store.registerModule('CodementumUrl', CodementumUrlStoreFacade());
  }
};

export default CodementumUrlPlugin;
